import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.5 5.75L7 9.25L10.5 5.75",
		stroke: "black",
		strokeWidth: 1.16667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export { SvgChevronDown as ReactComponent };
